export const FUNNEL_OPTIONS = [
  { value: "upper", emoji: "🔺", label: "Upper Funnel", tag: "Awareness", description: "Pull traffic & build awareness", objective: "Reach out to new customers who don't know your product yet", examples: ["Relatable problem", "Storytelling", "Point of view (POV)", "Trending hook"], color: "blue" },
  { value: "middle", emoji: "🔶", label: "Middle Funnel", tag: "Consideration", description: "Educate & build trust", objective: "Gain video views, community interaction and warm up leads", examples: ["Review / UGC", "Before & after", "Feature highlight", "Product demo"], color: "yellow" },
  { value: "lower", emoji: "🔻", label: "Lower Funnel", tag: "Conversion", description: "Drive purchase & close sales", objective: "Promotion, lead generation and direct purchase intent", examples: ["Limited offer", "CTA to buy", "Testimonial + price", "Urgency / scarcity"], color: "green" },
];

const PLATFORM_ASPECT = {
  tiktok: { ratio: "9:16", label: "9:16 vertical", gemini: "9:16" },
  reels: { ratio: "9:16", label: "9:16 vertical", gemini: "9:16" },
  youtube_shorts: { ratio: "9:16", label: "9:16 vertical", gemini: "9:16" },
  youtube_main: { ratio: "16:9", label: "16:9 landscape", gemini: "16:9" },
  feed_square: { ratio: "1:1", label: "1:1 square", gemini: "1:1" },
};

const o = (key, lang) => {
  const v = OPTS[key];
  if (!v) return [];
  if (Array.isArray(v)) return v;
  return v[lang] || v.en || [];
};

const OPTS = {
  platform: [
    { value: "tiktok", label: "TikTok (9:16)" },
    { value: "reels", label: "Instagram Reels (9:16)" },
    { value: "youtube_shorts", label: "YouTube Shorts (9:16)" },
    { value: "youtube_main", label: "YouTube Main (16:9)" },
    { value: "feed_square", label: "Feed Post (1:1)" },
  ],
  grokPlan: {
    en: [
      { value: "free", label: "🆓 Grok Free (6s per clip)" },
      { value: "pro", label: "⭐ Grok Pro (10s per clip)" },
    ],
    zh: [
      { value: "free", label: "🆓 Grok 免费版（每片段6秒）" },
      { value: "pro", label: "⭐ Grok Pro（每片段10秒）" },
    ],
    bm: [
      { value: "free", label: "🆓 Grok Percuma (6s setiap klip)" },
      { value: "pro", label: "⭐ Grok Pro (10s setiap klip)" },
    ],
  },
  productCategory: {
    en: [
      { value: "", label: "— Select category —" },
      { value: "tech_gadget", label: "Physical — tech gadget" },
      { value: "consumer_good", label: "Physical — consumer good" },
      { value: "skincare", label: "Physical — skincare / beauty" },
      { value: "vitamin_health", label: "Physical — vitamin / health" },
      { value: "apparel", label: "Physical — apparel / fashion" },
      { value: "food_beverage", label: "Physical — food & beverage" },
      { value: "home_living", label: "Physical — home & living" },
      { value: "software_app", label: "Software / app" },
      { value: "service", label: "Service" },
      { value: "event_campaign", label: "Event / campaign" },
      { value: "other", label: "Other — type below" },
    ],
    zh: [
      { value: "", label: "— 选择类别 —" },
      { value: "tech_gadget", label: "实体 — 科技产品" },
      { value: "consumer_good", label: "实体 — 消费品" },
      { value: "skincare", label: "实体 — 护肤/美妆" },
      { value: "vitamin_health", label: "实体 — 维生素/健康" },
      { value: "apparel", label: "实体 — 服装/时尚" },
      { value: "food_beverage", label: "实体 — 食品&饮料" },
      { value: "home_living", label: "实体 — 家居&生活" },
      { value: "software_app", label: "软件/应用" },
      { value: "service", label: "服务" },
      { value: "event_campaign", label: "活动/营销" },
      { value: "other", label: "其他 — 请在下方填写" },
    ],
    bm: [
      { value: "", label: "— Pilih kategori —" },
      { value: "tech_gadget", label: "Fizikal — alat teknologi" },
      { value: "consumer_good", label: "Fizikal — barangan pengguna" },
      { value: "skincare", label: "Fizikal — penjagaan kulit / kecantikan" },
      { value: "vitamin_health", label: "Fizikal — vitamin / kesihatan" },
      { value: "apparel", label: "Fizikal — pakaian / fesyen" },
      { value: "food_beverage", label: "Fizikal — makanan & minuman" },
      { value: "home_living", label: "Fizikal — rumah & kehidupan" },
      { value: "software_app", label: "Perisian / aplikasi" },
      { value: "service", label: "Perkhidmatan" },
      { value: "event_campaign", label: "Acara / kempen" },
      { value: "other", label: "Lain-lain — taip di bawah" },
    ],
  },
  targetAudience: {
    en: [
      { value: "students", label: "Students" },
      { value: "young_professionals", label: "Young professionals" },
      { value: "remote_workers", label: "Remote workers" },
      { value: "gamers", label: "Gamers" },
      { value: "business_exec", label: "Business users" },
      { value: "homemakers", label: "Homemakers" },
      { value: "parents", label: "Parents" },
      { value: "general", label: "General audience" },
    ],
    zh: [
      { value: "students", label: "学生" },
      { value: "young_professionals", label: "年轻职场人士" },
      { value: "remote_workers", label: "远程工作者" },
      { value: "gamers", label: "游戏玩家" },
      { value: "business_exec", label: "商务用户" },
      { value: "homemakers", label: "家庭主妇/主夫" },
      { value: "parents", label: "父母" },
      { value: "general", label: "大众受众" },
    ],
    bm: [
      { value: "students", label: "Pelajar" },
      { value: "young_professionals", label: "Profesional muda" },
      { value: "remote_workers", label: "Pekerja jauh" },
      { value: "gamers", label: "Gamer" },
      { value: "business_exec", label: "Pengguna perniagaan" },
      { value: "homemakers", label: "Suri rumah" },
      { value: "parents", label: "Ibu bapa" },
      { value: "general", label: "Audiens umum" },
    ],
  },
  videoStyle: {
    en: [
      { value: "ugc", label: "UGC — authentic, shot-on-phone" },
      { value: "commercial", label: "Commercial — polished, studio-lite" },
      { value: "lifestyle", label: "Lifestyle — candid, everyday" },
      { value: "tutorial", label: "Tutorial / How-to" },
      { value: "testimonial", label: "Testimonial — talking to camera" },
      { value: "unboxing", label: "Unboxing — reveal & first impression" },
      { value: "animated", label: "Animated / motion graphic" },
      { value: "minimal_clean", label: "Minimal, clean, modern" },
    ],
    zh: [
      { value: "ugc", label: "UGC — 真实感，手机拍摄" },
      { value: "commercial", label: "商业广告 — 精致，轻商业" },
      { value: "lifestyle", label: "生活方式 — 随性，日常" },
      { value: "tutorial", label: "教程 / 操作说明" },
      { value: "testimonial", label: "见证式 — 对着镜头讲话" },
      { value: "unboxing", label: "开箱 — 揭秘与第一印象" },
      { value: "animated", label: "动画 / 动态图形" },
      { value: "minimal_clean", label: "简洁，干净，现代" },
    ],
    bm: [
      { value: "ugc", label: "UGC — autentik, rakaman telefon" },
      { value: "commercial", label: "Komersial — halus, studio-lite" },
      { value: "lifestyle", label: "Gaya hidup — candid, harian" },
      { value: "tutorial", label: "Tutorial / Cara-cara" },
      { value: "testimonial", label: "Testimoni — bercakap ke kamera" },
      { value: "unboxing", label: "Unboxing — pendedahan & kesan pertama" },
      { value: "animated", label: "Animasi / grafik bergerak" },
      { value: "minimal_clean", label: "Minimalis, bersih, moden" },
    ],
  },
  tone: {
    en: [
      { value: "calm_warm", label: "Calm & warm" },
      { value: "energetic", label: "Energetic & upbeat" },
      { value: "trustworthy", label: "Trustworthy" },
      { value: "friendly", label: "Friendly" },
      { value: "professional", label: "Professional" },
      { value: "fun_playful", label: "Fun & playful" },
      { value: "inspirational", label: "Inspirational" },
      { value: "relatable", label: "Relatable & everyday" },
    ],
    zh: [
      { value: "calm_warm", label: "平静温暖" },
      { value: "energetic", label: "充满活力" },
      { value: "trustworthy", label: "值得信赖" },
      { value: "friendly", label: "亲切友好" },
      { value: "professional", label: "专业" },
      { value: "fun_playful", label: "有趣活泼" },
      { value: "inspirational", label: "励志感人" },
      { value: "relatable", label: "贴近生活" },
    ],
    bm: [
      { value: "calm_warm", label: "Tenang & mesra" },
      { value: "energetic", label: "Bertenaga & ceria" },
      { value: "trustworthy", label: "Boleh dipercayai" },
      { value: "friendly", label: "Mesra" },
      { value: "professional", label: "Profesional" },
      { value: "fun_playful", label: "Seronok & playful" },
      { value: "inspirational", label: "Inspirasi" },
      { value: "relatable", label: "Mudah dikaitkan & harian" },
    ],
  },
  realism: {
    en: [
      { value: "realistic", label: "Realistic live-action" },
      { value: "stylized", label: "Stylized but realistic" },
      { value: "animated", label: "Cartoon / fully animated" },
    ],
    zh: [
      { value: "realistic", label: "写实真人拍摄" },
      { value: "stylized", label: "风格化但写实" },
      { value: "animated", label: "卡通 / 全动画" },
    ],
    bm: [
      { value: "realistic", label: "Aksi sebenar yang realistik" },
      { value: "stylized", label: "Bergaya tetapi realistik" },
      { value: "animated", label: "Kartun / animasi penuh" },
    ],
  },
  colorGrading: {
    en: [
      { value: "warm_golden", label: "Warm / golden hour" },
      { value: "cool_blue", label: "Cool / bluish tech" },
      { value: "neutral_natural", label: "Neutral / natural" },
      { value: "high_contrast", label: "High contrast / punchy" },
      { value: "soft_pastel", label: "Soft / pastel" },
    ],
    zh: [
      { value: "warm_golden", label: "暖色 / 黄金时段" },
      { value: "cool_blue", label: "冷色 / 科技蓝" },
      { value: "neutral_natural", label: "中性 / 自然" },
      { value: "high_contrast", label: "高对比 / 强烈" },
      { value: "soft_pastel", label: "柔和 / 粉彩" },
    ],
    bm: [
      { value: "warm_golden", label: "Hangat / waktu emas" },
      { value: "cool_blue", label: "Sejuk / teknologi kebiruan" },
      { value: "neutral_natural", label: "Neutral / semula jadi" },
      { value: "high_contrast", label: "Kontras tinggi / bertenaga" },
      { value: "soft_pastel", label: "Lembut / pastel" },
    ],
  },
  authenticity: {
    en: [
      { value: "natural_not_staged", label: "Natural, not staged" },
      { value: "real_user_video", label: "Looks like a real user's video" },
      { value: "casual_vlog", label: "Feels like a casual vlog" },
      { value: "polished_professional", label: "Polished and professional" },
    ],
    zh: [
      { value: "natural_not_staged", label: "自然，非刻意摆拍" },
      { value: "real_user_video", label: "看起来像真实用户的视频" },
      { value: "casual_vlog", label: "像随性的Vlog" },
      { value: "polished_professional", label: "精致专业" },
    ],
    bm: [
      { value: "natural_not_staged", label: "Semula jadi, tidak berlakon" },
      { value: "real_user_video", label: "Kelihatan seperti video pengguna sebenar" },
      { value: "casual_vlog", label: "Terasa seperti vlog santai" },
      { value: "polished_professional", label: "Halus dan profesional" },
    ],
  },
  settingPreset: {
    en: [
      { value: "", label: "— Select preset —" },
      { value: "home_kitchen", label: "Home — kitchen" },
      { value: "home_living", label: "Home — living room" },
      { value: "home_bedroom", label: "Home — bedroom" },
      { value: "home_outdoor", label: "Home — outdoor / garden" },
      { value: "cafe", label: "Café / coffee shop" },
      { value: "office", label: "Office / workspace" },
      { value: "outdoor_urban", label: "Outdoor — urban street" },
      { value: "outdoor_nature", label: "Outdoor — nature / park" },
      { value: "gym", label: "Gym / fitness space" },
      { value: "studio_neutral", label: "Studio — neutral background" },
      { value: "custom", label: "✏️ Custom (type below)" },
    ],
    zh: [
      { value: "", label: "— 选择预设 —" },
      { value: "home_kitchen", label: "家 — 厨房" },
      { value: "home_living", label: "家 — 客厅" },
      { value: "home_bedroom", label: "家 — 卧室" },
      { value: "home_outdoor", label: "家 — 户外/花园" },
      { value: "cafe", label: "咖啡馆" },
      { value: "office", label: "办公室/工作空间" },
      { value: "outdoor_urban", label: "户外 — 城市街道" },
      { value: "outdoor_nature", label: "户外 — 自然/公园" },
      { value: "gym", label: "健身房" },
      { value: "studio_neutral", label: "影棚 — 中性背景" },
      { value: "custom", label: "✏️ 自定义（在下方填写）" },
    ],
    bm: [
      { value: "", label: "— Pilih pratetap —" },
      { value: "home_kitchen", label: "Rumah — dapur" },
      { value: "home_living", label: "Rumah — ruang tamu" },
      { value: "home_bedroom", label: "Rumah — bilik tidur" },
      { value: "home_outdoor", label: "Rumah — luar/taman" },
      { value: "cafe", label: "Kafe / kedai kopi" },
      { value: "office", label: "Pejabat / ruang kerja" },
      { value: "outdoor_urban", label: "Luar — jalan bandar" },
      { value: "outdoor_nature", label: "Luar — alam semula jadi / taman" },
      { value: "gym", label: "Gim / ruang kecergasan" },
      { value: "studio_neutral", label: "Studio — latar belakang neutral" },
      { value: "custom", label: "✏️ Tersuai (taip di bawah)" },
    ],
  },
  lightingPreset: {
    en: [
      { value: "", label: "— Select preset —" },
      { value: "natural_day", label: "Natural daylight (bright, airy)" },
      { value: "golden_hour", label: "Golden hour / warm afternoon" },
      { value: "indoor_warm", label: "Indoor warm artificial light" },
      { value: "indoor_cool", label: "Indoor cool / neutral light" },
      { value: "studio_soft", label: "Studio soft box (clean, even)" },
      { value: "moody_low", label: "Moody low light (dramatic)" },
      { value: "custom", label: "✏️ Custom (type below)" },
    ],
    zh: [
      { value: "", label: "— 选择预设 —" },
      { value: "natural_day", label: "自然日光（明亮通透）" },
      { value: "golden_hour", label: "黄金时段 / 温暖下午" },
      { value: "indoor_warm", label: "室内暖色人工光" },
      { value: "indoor_cool", label: "室内冷色/中性光" },
      { value: "studio_soft", label: "影棚柔光（干净均匀）" },
      { value: "moody_low", label: "低调昏暗光（戏剧感）" },
      { value: "custom", label: "✏️ 自定义（在下方填写）" },
    ],
    bm: [
      { value: "", label: "— Pilih pratetap —" },
      { value: "natural_day", label: "Cahaya siang semula jadi (cerah, lapang)" },
      { value: "golden_hour", label: "Waktu emas / petang hangat" },
      { value: "indoor_warm", label: "Cahaya buatan dalam hangat" },
      { value: "indoor_cool", label: "Cahaya dalam sejuk / neutral" },
      { value: "studio_soft", label: "Soft box studio (bersih, sekata)" },
      { value: "moody_low", label: "Cahaya rendah dramatik" },
      { value: "custom", label: "✏️ Tersuai (taip di bawah)" },
    ],
  },
  bgActivity: {
    en: [
      { value: "calm_still", label: "Calm, almost no movement" },
      { value: "light_activity", label: "Light activity, not distracting" },
      { value: "busy_dynamic", label: "Busy / dynamic background" },
    ],
    zh: [
      { value: "calm_still", label: "平静，几乎没有动作" },
      { value: "light_activity", label: "轻微活动，不分散注意力" },
      { value: "busy_dynamic", label: "繁忙 / 动态背景" },
    ],
    bm: [
      { value: "calm_still", label: "Tenang, hampir tiada pergerakan" },
      { value: "light_activity", label: "Aktiviti ringan, tidak mengganggu" },
      { value: "busy_dynamic", label: "Sibuk / latar belakang dinamik" },
    ],
  },
  talent: {
    en: [
      { value: "solo_female", label: "Solo female (25–35)" },
      { value: "solo_male", label: "Solo male (25–35)" },
      { value: "solo_female_mature", label: "Solo female (40–55)" },
      { value: "solo_male_mature", label: "Solo male (40–55)" },
      { value: "couple", label: "Couple" },
      { value: "group_friends", label: "Group of friends" },
      { value: "family", label: "Family (adult + child)" },
      { value: "no_talent", label: "No talent — product only" },
    ],
    zh: [
      { value: "solo_female", label: "单人女性（25–35岁）" },
      { value: "solo_male", label: "单人男性（25–35岁）" },
      { value: "solo_female_mature", label: "单人女性（40–55岁）" },
      { value: "solo_male_mature", label: "单人男性（40–55岁）" },
      { value: "couple", label: "情侣" },
      { value: "group_friends", label: "朋友群体" },
      { value: "family", label: "家庭（成人+儿童）" },
      { value: "no_talent", label: "无演员 — 仅展示产品" },
    ],
    bm: [
      { value: "solo_female", label: "Perempuan solo (25–35)" },
      { value: "solo_male", label: "Lelaki solo (25–35)" },
      { value: "solo_female_mature", label: "Perempuan solo (40–55)" },
      { value: "solo_male_mature", label: "Lelaki solo (40–55)" },
      { value: "couple", label: "Pasangan" },
      { value: "group_friends", label: "Kumpulan kawan" },
      { value: "family", label: "Keluarga (dewasa + kanak-kanak)" },
      { value: "no_talent", label: "Tiada pelakon — produk sahaja" },
    ],
  },
  talentStyle: {
    en: [
      { value: "casual", label: "Casual" },
      { value: "smart_casual", label: "Smart casual" },
      { value: "modest", label: "Modest / conservative" },
      { value: "sporty", label: "Sporty / activewear" },
      { value: "professional", label: "Professional" },
      { value: "cultural", label: "Cultural / traditional" },
    ],
    zh: [
      { value: "casual", label: "休闲" },
      { value: "smart_casual", label: "时尚休闲" },
      { value: "modest", label: "端庄保守" },
      { value: "sporty", label: "运动风" },
      { value: "professional", label: "职业装" },
      { value: "cultural", label: "民族/传统服饰" },
    ],
    bm: [
      { value: "casual", label: "Kasual" },
      { value: "smart_casual", label: "Smart kasual" },
      { value: "modest", label: "Sopan / konservatif" },
      { value: "sporty", label: "Sukan / pakaian aktif" },
      { value: "professional", label: "Profesional" },
      { value: "cultural", label: "Budaya / tradisional" },
    ],
  },
  emotion: {
    en: [
      { value: "frustrated_stressed", label: "Frustrated / stressed" },
      { value: "focused", label: "Focused / concentrating" },
      { value: "happy_relieved", label: "Happy / relieved" },
      { value: "excited", label: "Excited" },
      { value: "calm_relaxed", label: "Calm / relaxed" },
      { value: "arc_frustrated_relieved", label: "Arc: frustrated → relieved" },
      { value: "arc_curious_impressed", label: "Arc: curious → impressed" },
      { value: "arc_neutral_excited", label: "Arc: neutral → excited" },
    ],
    zh: [
      { value: "frustrated_stressed", label: "沮丧 / 焦虑" },
      { value: "focused", label: "专注 / 集中" },
      { value: "happy_relieved", label: "开心 / 释然" },
      { value: "excited", label: "兴奋" },
      { value: "calm_relaxed", label: "平静 / 放松" },
      { value: "arc_frustrated_relieved", label: "弧线：沮丧 → 释然" },
      { value: "arc_curious_impressed", label: "弧线：好奇 → 印象深刻" },
      { value: "arc_neutral_excited", label: "弧线：平淡 → 兴奋" },
    ],
    bm: [
      { value: "frustrated_stressed", label: "Kecewa / tertekan" },
      { value: "focused", label: "Fokus / menumpukan" },
      { value: "happy_relieved", label: "Gembira / lega" },
      { value: "excited", label: "Teruja" },
      { value: "calm_relaxed", label: "Tenang / relaks" },
      { value: "arc_frustrated_relieved", label: "Lengkok: kecewa → lega" },
      { value: "arc_curious_impressed", label: "Lengkok: ingin tahu → terkesan" },
      { value: "arc_neutral_excited", label: "Lengkok: neutral → teruja" },
    ],
  },
  shotType: {
    en: [
      { value: "close_up", label: "Close-up" },
      { value: "medium_shot", label: "Medium shot (waist up)" },
      { value: "wide_shot", label: "Wide shot (full body + env)" },
      { value: "product_closeup", label: "Product close-up" },
    ],
    zh: [
      { value: "close_up", label: "特写" },
      { value: "medium_shot", label: "中景（腰部以上）" },
      { value: "wide_shot", label: "远景（全身+环境）" },
      { value: "product_closeup", label: "产品特写" },
    ],
    bm: [
      { value: "close_up", label: "Close-up" },
      { value: "medium_shot", label: "Tembakan sederhana (pinggang ke atas)" },
      { value: "wide_shot", label: "Tembakan lebar (seluruh badan + persekitaran)" },
      { value: "product_closeup", label: "Close-up produk" },
    ],
  },
  cameraAngle: {
    en: [
      { value: "eye_level", label: "Eye-level" },
      { value: "slight_high", label: "Slight high angle" },
      { value: "slight_low", label: "Slight low angle" },
      { value: "top_down", label: "Top-down" },
    ],
    zh: [
      { value: "eye_level", label: "平视角" },
      { value: "slight_high", label: "略高俯角" },
      { value: "slight_low", label: "略低仰角" },
      { value: "top_down", label: "俯拍" },
    ],
    bm: [
      { value: "eye_level", label: "Paras mata" },
      { value: "slight_high", label: "Sudut tinggi sedikit" },
      { value: "slight_low", label: "Sudut rendah sedikit" },
      { value: "top_down", label: "Dari atas ke bawah" },
    ],
  },
  cameraMove: {
    en: [
      { value: "static", label: "Mostly static" },
      { value: "gentle_handheld", label: "Gentle handheld" },
      { value: "slow_push_in", label: "Slow push-in" },
      { value: "slow_pull_back", label: "Slow pull-back" },
      { value: "pan_follow", label: "Pan / follow subject" },
      { value: "mixed", label: "Mixed" },
    ],
    zh: [
      { value: "static", label: "基本静止" },
      { value: "gentle_handheld", label: "轻微手持" },
      { value: "slow_push_in", label: "缓慢推进" },
      { value: "slow_pull_back", label: "缓慢后拉" },
      { value: "pan_follow", label: "摇镜/跟拍主体" },
      { value: "mixed", label: "混合" },
    ],
    bm: [
      { value: "static", label: "Kebanyakannya statik" },
      { value: "gentle_handheld", label: "Genggaman tangan lembut" },
      { value: "slow_push_in", label: "Tolak masuk perlahan" },
      { value: "slow_pull_back", label: "Tarik balik perlahan" },
      { value: "pan_follow", label: "Pan / ikut subjek" },
      { value: "mixed", label: "Campuran" },
    ],
  },
  heroAngle: {
    en: [
      { value: "", label: "— Select —" },
      { value: "45_elevated", label: "45° elevated (recommended)" },
      { value: "eye_level", label: "Eye-level straight-on" },
      { value: "top_down", label: "Top-down / flat-lay" },
      { value: "low_angle", label: "Low angle (prestige)" },
      { value: "close_up_detail", label: "Close-up on key detail" },
    ],
    zh: [
      { value: "", label: "— 选择 —" },
      { value: "45_elevated", label: "45°仰角（推荐）" },
      { value: "eye_level", label: "平视正面" },
      { value: "top_down", label: "俯拍 / 平铺" },
      { value: "low_angle", label: "低角度（高级感）" },
      { value: "close_up_detail", label: "关键细节特写" },
    ],
    bm: [
      { value: "", label: "— Pilih —" },
      { value: "45_elevated", label: "45° tinggi (disyorkan)" },
      { value: "eye_level", label: "Paras mata terus" },
      { value: "top_down", label: "Dari atas / flat-lay" },
      { value: "low_angle", label: "Sudut rendah (prestij)" },
      { value: "close_up_detail", label: "Close-up pada butiran utama" },
    ],
  },
  productFraming: {
    en: [
      { value: "fully_visible", label: "Product fully visible" },
      { value: "centered", label: "Product centered" },
      { value: "rule_of_thirds", label: "Rule of thirds" },
      { value: "bg_blurred", label: "Background blurred, product sharp" },
    ],
    zh: [
      { value: "fully_visible", label: "产品完整可见" },
      { value: "centered", label: "产品居中" },
      { value: "rule_of_thirds", label: "三分法构图" },
      { value: "bg_blurred", label: "背景虚化，产品清晰" },
    ],
    bm: [
      { value: "fully_visible", label: "Produk kelihatan sepenuhnya" },
      { value: "centered", label: "Produk di tengah" },
      { value: "rule_of_thirds", label: "Peraturan sepertiga" },
      { value: "bg_blurred", label: "Latar kabur, produk tajam" },
    ],
  },
  subjectMotion: {
    en: [
      { value: "typing_clicking", label: "Typing / clicking" },
      { value: "looking_around", label: "Looking around stressed, then relaxing" },
      { value: "picking_up_product", label: "Picking up & using product" },
      { value: "pointing_at_screen", label: "Pointing at screen" },
      { value: "walking_moving", label: "Walking / moving naturally" },
    ],
    zh: [
      { value: "typing_clicking", label: "打字 / 点击" },
      { value: "looking_around", label: "焦虑地环顾四周，然后放松" },
      { value: "picking_up_product", label: "拿起并使用产品" },
      { value: "pointing_at_screen", label: "指向屏幕" },
      { value: "walking_moving", label: "自然走动" },
    ],
    bm: [
      { value: "typing_clicking", label: "Menaip / mengklik" },
      { value: "looking_around", label: "Melihat sekeliling dengan tekanan, kemudian relaks" },
      { value: "picking_up_product", label: "Mengambil & menggunakan produk" },
      { value: "pointing_at_screen", label: "Menunjuk ke skrin" },
      { value: "walking_moving", label: "Berjalan / bergerak secara semula jadi" },
    ],
  },
  productInteraction: {
    en: [
      { value: "plug_in", label: "Plug into laptop / phone" },
      { value: "turn_on", label: "Turn product on" },
      { value: "drag_windows", label: "Drag apps / windows onto screen" },
      { value: "hold_in_hand", label: "Hold in hand while moving" },
      { value: "unbox_reveal", label: "Unbox / reveal product" },
      { value: "apply_use", label: "Apply / use on skin / body" },
    ],
    zh: [
      { value: "plug_in", label: "插入笔记本/手机" },
      { value: "turn_on", label: "开启产品" },
      { value: "drag_windows", label: "将应用/窗口拖到屏幕上" },
      { value: "hold_in_hand", label: "边走边手持" },
      { value: "unbox_reveal", label: "开箱/揭示产品" },
      { value: "apply_use", label: "涂抹/在皮肤/身体上使用" },
    ],
    bm: [
      { value: "plug_in", label: "Pasang ke laptop / telefon" },
      { value: "turn_on", label: "Hidupkan produk" },
      { value: "drag_windows", label: "Seret apl / tetingkap ke skrin" },
      { value: "hold_in_hand", label: "Pegang di tangan semasa bergerak" },
      { value: "unbox_reveal", label: "Unbox / dedahkan produk" },
      { value: "apply_use", label: "Sapu / guna pada kulit / badan" },
    ],
  },
  emotionalArc: {
    en: [
      { value: "frustrated_relieved", label: "Frustrated → relieved" },
      { value: "curious_impressed", label: "Curious → impressed" },
      { value: "neutral_excited", label: "Neutral → excited" },
      { value: "calm_confident", label: "Calm → confident" },
    ],
    zh: [
      { value: "frustrated_relieved", label: "沮丧 → 释然" },
      { value: "curious_impressed", label: "好奇 → 印象深刻" },
      { value: "neutral_excited", label: "平淡 → 兴奋" },
      { value: "calm_confident", label: "平静 → 自信" },
    ],
    bm: [
      { value: "frustrated_relieved", label: "Kecewa → lega" },
      { value: "curious_impressed", label: "Ingin tahu → terkesan" },
      { value: "neutral_excited", label: "Neutral → teruja" },
      { value: "calm_confident", label: "Tenang → yakin" },
    ],
  },
  endingFrame: {
    en: [
      { value: "hero_product", label: "Hero product shot" },
      { value: "user_happy", label: "User happily using product" },
      { value: "product_branding", label: "Product + subtle branding" },
      { value: "cta_frame", label: "CTA-focused final frame" },
    ],
    zh: [
      { value: "hero_product", label: "产品主镜头" },
      { value: "user_happy", label: "用户愉快使用产品" },
      { value: "product_branding", label: "产品+subtle品牌" },
      { value: "cta_frame", label: "以CTA为重点的最终帧" },
    ],
    bm: [
      { value: "hero_product", label: "Tembakan hero produk" },
      { value: "user_happy", label: "Pengguna gembira menggunakan produk" },
      { value: "product_branding", label: "Produk + jenama halus" },
      { value: "cta_frame", label: "Bingkai akhir berfokus CTA" },
    ],
  },
  hooks: {
    en: [
      { value: "question", label: "Open with a question" },
      { value: "bold_claim", label: "Bold claim / statement" },
      { value: "problem_agitate", label: "Problem → agitate → solve" },
      { value: "reveal", label: "Unexpected reveal" },
      { value: "social_proof", label: "Social proof opener" },
      { value: "before_after", label: "Before & after contrast" },
      { value: "pov", label: "POV (point-of-view) shot" },
    ],
    zh: [
      { value: "question", label: "以问题开场" },
      { value: "bold_claim", label: "大胆声明/陈述" },
      { value: "problem_agitate", label: "问题 → 激化 → 解决" },
      { value: "reveal", label: "意外揭示" },
      { value: "social_proof", label: "社会证明开场" },
      { value: "before_after", label: "前后对比" },
      { value: "pov", label: "第一视角镜头" },
    ],
    bm: [
      { value: "question", label: "Buka dengan soalan" },
      { value: "bold_claim", label: "Dakwaan / kenyataan berani" },
      { value: "problem_agitate", label: "Masalah → galakkan → selesai" },
      { value: "reveal", label: "Pendedahan mengejut" },
      { value: "social_proof", label: "Pembuka bukti sosial" },
      { value: "before_after", label: "Kontras sebelum & selepas" },
      { value: "pov", label: "Tembakan POV (sudut pandang)" },
    ],
  },
  cta: {
    en: [
      { value: "shop_link", label: "Shop via link in bio" },
      { value: "comment", label: "Comment for more info" },
      { value: "follow", label: "Follow for more" },
      { value: "save_post", label: "Save this post" },
      { value: "try_it", label: "Try it yourself" },
      { value: "visit_website", label: "Visit website" },
      { value: "sign_up", label: "Sign up now" },
      { value: "no_cta", label: "No explicit CTA" },
    ],
    zh: [
      { value: "shop_link", label: "通过简介链接购买" },
      { value: "comment", label: "评论获取更多信息" },
      { value: "follow", label: "关注以获取更多" },
      { value: "save_post", label: "收藏此帖子" },
      { value: "try_it", label: "自己试试" },
      { value: "visit_website", label: "访问网站" },
      { value: "sign_up", label: "立即注册" },
      { value: "no_cta", label: "无明确CTA" },
    ],
    bm: [
      { value: "shop_link", label: "Beli melalui pautan di bio" },
      { value: "comment", label: "Komen untuk maklumat lanjut" },
      { value: "follow", label: "Ikuti untuk lebih banyak" },
      { value: "save_post", label: "Simpan siaran ini" },
      { value: "try_it", label: "Cuba sendiri" },
      { value: "visit_website", label: "Lawati laman web" },
      { value: "sign_up", label: "Daftar sekarang" },
      { value: "no_cta", label: "Tiada CTA yang jelas" },
    ],
  },
  audioType: {
    en: [
      { value: "silent", label: "No audio (silent)" },
      { value: "ambient_only", label: "Natural ambient sound only" },
      { value: "vo_only", label: "Voiceover only" },
      { value: "ambient_vo", label: "Ambient + voiceover" },
    ],
    zh: [
      { value: "silent", label: "无音频（静音）" },
      { value: "ambient_only", label: "仅自然环境音" },
      { value: "vo_only", label: "仅配音" },
      { value: "ambient_vo", label: "环境音+配音" },
    ],
    bm: [
      { value: "silent", label: "Tiada audio (senyap)" },
      { value: "ambient_only", label: "Bunyi ambien semula jadi sahaja" },
      { value: "vo_only", label: "Suara latar sahaja" },
      { value: "ambient_vo", label: "Ambien + suara latar" },
    ],
  },
  voLang: {
    en: [
      { value: "", label: "— Select —" },
      { value: "english", label: "English" },
      { value: "bm", label: "Bahasa Malaysia" },
      { value: "mandarin", label: "Mandarin" },
      { value: "tamil", label: "Tamil" },
      { value: "codemix_bm_en", label: "BM + English (code-switch)" },
      { value: "none", label: "No voiceover (visual only)" },
    ],
    zh: [
      { value: "", label: "— 选择 —" },
      { value: "english", label: "英语" },
      { value: "bm", label: "马来语" },
      { value: "mandarin", label: "普通话" },
      { value: "tamil", label: "泰米尔语" },
      { value: "codemix_bm_en", label: "马来语+英语（混搭）" },
      { value: "none", label: "无配音（纯视觉）" },
    ],
    bm: [
      { value: "", label: "— Pilih —" },
      { value: "english", label: "Bahasa Inggeris" },
      { value: "bm", label: "Bahasa Malaysia" },
      { value: "mandarin", label: "Mandarin" },
      { value: "tamil", label: "Tamil" },
      { value: "codemix_bm_en", label: "BM + Inggeris (code-switch)" },
      { value: "none", label: "Tiada suara latar (visual sahaja)" },
    ],
  },
  speechType: {
    en: [
      { value: "no_speech", label: "No one speaking on camera" },
      { value: "on_camera", label: "Subject speaking on camera" },
      { value: "offscreen_vo", label: "Off-screen voiceover only" },
    ],
    zh: [
      { value: "no_speech", label: "镜头前无人说话" },
      { value: "on_camera", label: "主体对着镜头说话" },
      { value: "offscreen_vo", label: "仅画外音配音" },
    ],
    bm: [
      { value: "no_speech", label: "Tiada yang bercakap di kamera" },
      { value: "on_camera", label: "Subjek bercakap di kamera" },
      { value: "offscreen_vo", label: "Suara latar luar skrin sahaja" },
    ],
  },
  bgMusic: {
    en: [
      { value: "no_music", label: "No music" },
      { value: "soft_bg", label: "Soft background music" },
      { value: "upbeat", label: "Upbeat background music" },
      { value: "dramatic", label: "Dramatic / cinematic music" },
    ],
    zh: [
      { value: "no_music", label: "无音乐" },
      { value: "soft_bg", label: "轻柔背景音乐" },
      { value: "upbeat", label: "欢快背景音乐" },
      { value: "dramatic", label: "戏剧性/电影感音乐" },
    ],
    bm: [
      { value: "no_music", label: "Tiada muzik" },
      { value: "soft_bg", label: "Muzik latar lembut" },
      { value: "upbeat", label: "Muzik latar ceria" },
      { value: "dramatic", label: "Muzik dramatik / sinematik" },
    ],
  },
  frameRate: {
    en: [
      { value: "24fps", label: "24fps — cinematic" },
      { value: "30fps", label: "30fps — standard" },
      { value: "60fps", label: "60fps — very smooth" },
    ],
    zh: [
      { value: "24fps", label: "24fps — 电影感" },
      { value: "30fps", label: "30fps — 标准" },
      { value: "60fps", label: "60fps — 非常流畅" },
    ],
    bm: [
      { value: "24fps", label: "24fps — sinematik" },
      { value: "30fps", label: "30fps — standard" },
      { value: "60fps", label: "60fps — sangat lancar" },
    ],
  },
  resolution: {
    en: [
      { value: "1080p", label: "1080p Full HD" },
      { value: "1440p", label: "1440p" },
      { value: "720p", label: "720p" },
      { value: "best", label: "Best quality available" },
    ],
    zh: [
      { value: "1080p", label: "1080p 全高清" },
      { value: "1440p", label: "1440p" },
      { value: "720p", label: "720p" },
      { value: "best", label: "最高可用画质" },
    ],
    bm: [
      { value: "1080p", label: "1080p Full HD" },
      { value: "1440p", label: "1440p" },
      { value: "720p", label: "720p" },
      { value: "best", label: "Kualiti terbaik yang tersedia" },
    ],
  },
  depthOfField: {
    en: [
      { value: "subject_sharp_bg_blur", label: "Subject & product sharp, BG slightly blurred" },
      { value: "everything_sharp", label: "Everything in focus" },
      { value: "product_sharp", label: "Product sharp, BG blurred" },
    ],
    zh: [
      { value: "subject_sharp_bg_blur", label: "主体和产品清晰，背景略微虚化" },
      { value: "everything_sharp", label: "全部清晰对焦" },
      { value: "product_sharp", label: "产品清晰，背景虚化" },
    ],
    bm: [
      { value: "subject_sharp_bg_blur", label: "Subjek & produk tajam, latar sedikit kabur" },
      { value: "everything_sharp", label: "Semua dalam fokus" },
      { value: "product_sharp", label: "Produk tajam, latar kabur" },
    ],
  },
  antiHallucination: {
    en: [
      { value: "no_extra_limbs", label: "No extra limbs / fingers" },
      { value: "no_warped_faces", label: "No warped faces" },
      { value: "no_floating_objects", label: "No floating objects" },
      { value: "no_random_ui", label: "No random UI / screens floating" },
      { value: "no_fictional_features", label: "No fictional product features" },
    ],
    zh: [
      { value: "no_extra_limbs", label: "无多余肢体/手指" },
      { value: "no_warped_faces", label: "无扭曲面孔" },
      { value: "no_floating_objects", label: "无漂浮物体" },
      { value: "no_random_ui", label: "无随机浮动的UI/屏幕" },
      { value: "no_fictional_features", label: "无虚构产品功能" },
    ],
    bm: [
      { value: "no_extra_limbs", label: "Tiada anggota / jari tambahan" },
      { value: "no_warped_faces", label: "Tiada muka yang herot" },
      { value: "no_floating_objects", label: "Tiada objek terapung" },
      { value: "no_random_ui", label: "Tiada UI / skrin terapung rawak" },
      { value: "no_fictional_features", label: "Tiada ciri produk rekaan" },
    ],
  },
  restrictions: {
    en: [
      { value: "no_text_overlay", label: "No text overlay" },
      { value: "no_effects", label: "No artificial effects" },
      { value: "no_exaggerated_acting", label: "No exaggerated acting" },
      { value: "no_influencer_vibe", label: "No influencer vibe" },
      { value: "no_branded_bg", label: "No branded items in BG" },
      { value: "no_children", label: "No children in frame" },
      { value: "halal_visual", label: "Visually halal-compliant" },
      { value: "no_male_talent", label: "No male talent" },
      { value: "no_competitor", label: "No competitor products" },
      { value: "match_reference", label: "Product must match reference image" },
      { value: "no_logo_change", label: "No changes to logo" },
    ],
    zh: [
      { value: "no_text_overlay", label: "无文字叠加" },
      { value: "no_effects", label: "无人工特效" },
      { value: "no_exaggerated_acting", label: "无夸张表演" },
      { value: "no_influencer_vibe", label: "无网红风格" },
      { value: "no_branded_bg", label: "背景无品牌物品" },
      { value: "no_children", label: "画面中无儿童" },
      { value: "halal_visual", label: "视觉符合清真要求" },
      { value: "no_male_talent", label: "无男性演员" },
      { value: "no_competitor", label: "无竞争对手产品" },
      { value: "match_reference", label: "产品必须与参考图像一致" },
      { value: "no_logo_change", label: "不得更改Logo" },
    ],
    bm: [
      { value: "no_text_overlay", label: "Tiada teks tindanan" },
      { value: "no_effects", label: "Tiada kesan buatan" },
      { value: "no_exaggerated_acting", label: "Tiada lakonan berlebihan" },
      { value: "no_influencer_vibe", label: "Tiada gaya influencer" },
      { value: "no_branded_bg", label: "Tiada item berjenama di latar" },
      { value: "no_children", label: "Tiada kanak-kanak dalam bingkai" },
      { value: "halal_visual", label: "Patuh halal secara visual" },
      { value: "no_male_talent", label: "Tiada pelakon lelaki" },
      { value: "no_competitor", label: "Tiada produk pesaing" },
      { value: "match_reference", label: "Produk mesti sepadan dengan imej rujukan" },
      { value: "no_logo_change", label: "Tiada perubahan pada logo" },
    ],
  },
};

export { PLATFORM_ASPECT, o, OPTS };
